import WidgetAbout from "./widget-about";

export default WidgetAbout;